import { useState } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import toast from 'react-hot-toast';
import api from '../../utils/api';
import '../../styles/Pages.css';

const FEEDBACK_CONFIG = {
    library: { label: 'Library Feedback', icon: '📚', desc: 'Share your experience with the college library.' },
    alumni: { label: 'Alumni Feedback', icon: '🎓', desc: 'As an alumnus, share your feedback about your college experience.' },
    employer: { label: 'Employer Feedback', icon: '💼', desc: 'Employers: share feedback on graduates from our college.' },
    parents: { label: 'Parents Feedback', icon: '👨‍👩‍👧', desc: 'Parents/guardians: share your feedback about college facilities and academics.' },
    student: { label: 'Student Feedback', icon: '📝', desc: 'Students: rate your academic and campus experience.' },
    teacher: { label: 'Teacher Feedback', icon: '🧑‍🏫', desc: 'Faculty: provide feedback on teaching resources and institutional support.' },
};

function FeedbackForm({ type }) {
    const config = FEEDBACK_CONFIG[type] || { label: 'Feedback', icon: '📋', desc: 'Submit your feedback.' };
    const [form, setForm] = useState({ name: '', email: '', department: '', rating: '5', message: '' });
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.message.trim()) return toast.error('Please add your feedback comments.');
        setSubmitting(true);
        try {
            await api.post('/feedback', { ...form, type });
            toast.success('Thank you! Your feedback has been submitted successfully.');
            setForm({ name: '', email: '', department: '', rating: '5', message: '' });
        } catch {
            toast.error('Submission failed. Please try again.');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="page-wrapper">
            <Navbar />
            <div className="page-hero">
                <p className="page-breadcrumb"><a href="/">Home</a> › Feedback › {config.label}</p>
                <h1>{config.icon} {config.label}</h1>
                <p>{config.desc}</p>
            </div>
            <div className="page-content">
                <div className="ext-links" style={{ marginBottom: '1.5rem' }}>
                    {Object.entries(FEEDBACK_CONFIG).map(([k, v]) => (
                        <a key={k} href={`/feedback/${k}`} className={`ext-link-chip ${k === type ? 'active-chip' : ''}`} style={k === type ? { background: '#1a3c5e', color: '#fff' } : {}}>
                            {v.icon} {v.label}
                        </a>
                    ))}
                </div>
                <div className="form-box">
                    <form onSubmit={handleSubmit}>
                        <div className="form-row">
                            <div className="form-group">
                                <label>Full Name *</label>
                                <input required value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="Your name" />
                            </div>
                            <div className="form-group">
                                <label>Email</label>
                                <input type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} placeholder="your@email.com" />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group">
                                <label>Department</label>
                                <select value={form.department} onChange={e => setForm({ ...form, department: e.target.value })}>
                                    <option value="">Select Department</option>
                                    <option>Arts</option>
                                    <option>Science</option>
                                    <option>Computer Science</option>
                                    <option>Physical Education</option>
                                    <option>Library</option>
                                    <option>General</option>
                                </select>
                            </div>
                            <div className="form-group">
                                <label>Rating (1–5)</label>
                                <select value={form.rating} onChange={e => setForm({ ...form, rating: e.target.value })}>
                                    {['5', '4', '3', '2', '1'].map(r => <option key={r}>{r} ⭐</option>)}
                                </select>
                            </div>
                        </div>
                        <div className="form-group">
                            <label>Your Feedback *</label>
                            <textarea required value={form.message} onChange={e => setForm({ ...form, message: e.target.value })} placeholder="Write your detailed feedback here..." rows={5} />
                        </div>
                        <button type="submit" className="submit-btn" disabled={submitting}>
                            {submitting ? 'Submitting…' : '📩 Submit Feedback'}
                        </button>
                    </form>
                </div>
            </div>
            <Footer />
        </div>
    );
}
export default FeedbackForm;
